// v3 login page — Google Workspace SSO via Google Identity Services.
// Replaces the prior /v2?next=... redirect so users see / both before and
// after login (no v2 URL bounce).
//
// The sign-in dance itself (poll for GIS, read /auth/public-config, initialize,
// render the Google button, POST the credential to the staff endpoint) lives in
// lib/hooks/use-google-staff-signin.js — shared with Zephyr, the standalone
// front-office site, so both staff sign-in screens behave identically. This file is only the
// SPA's presentation of it. The GIS client script tag stays in
// public/v3/index.html (async defer, nonce-stamped by serveWithNonce).
//
// On success the hook calls onAuthenticated(user) so main.jsx flips authState
// to 'ok' and the SPA renders without a page reload.

import React from 'react';
import { useGoogleStaffSignIn } from '../lib/hooks/use-google-staff-signin';

const GRADIENT = 'linear-gradient(135deg, #0F1D35 0%, #1a2d4a 50%, #0F1D35 100%)';

function PlusBadge() {
  return (
    <svg width="48" height="48" viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <rect width="40" height="40" rx="10" fill="#0C7FDA" />
      <rect x="16" y="8" width="8" height="24" rx="2" fill="#fff" />
      <rect x="8" y="16" width="24" height="8" rx="2" fill="#fff" />
    </svg>
  );
}

export function LoginPage({ onAuthenticated }) {
  const { buttonRef, status, signing } = useGoogleStaffSignIn({ onAuthenticated });

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="v3-login-title"
      style={{
        position: 'fixed',
        inset: 0,
        background: GRADIENT,
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}>
      <div style={{
        background: '#fff',
        borderRadius: 14,
        padding: '40px 48px',
        textAlign: 'center',
        boxShadow: '0 24px 64px rgba(0,0,0,0.35)',
        maxWidth: 400,
        width: '90%',
      }}>
        <div style={{ marginBottom: 12 }}><PlusBadge /></div>
        <div id="v3-login-title" style={{ fontSize: 20, fontWeight: 700, color: '#0F1D35', marginBottom: 4 }}>
          CCM Compliance Manager
        </div>
        <div style={{ fontSize: 13, color: '#5b6678', marginBottom: 24 }}>
          Sign in with your work Google account
        </div>
        <div ref={buttonRef} style={{ display: 'flex', justifyContent: 'center', minHeight: 44 }} />
        <div
          role="status"
          aria-live="polite"
          style={{ marginTop: 12, fontSize: 13, color: signing ? '#5b6678' : '#d33', minHeight: 18 }}>
          {status}
        </div>
      </div>
    </div>
  );
}
